import multipleSearch from './reducer';

export default multipleSearch;
